const trackEvent = (name, params) => (dispatch, getState, { wixCodeApi }) => {
  wixCodeApi.window.trackEvent(name, params);
};

export default trackEvent;
